import AddIcon from "@mui/icons-material/Add";
import CreateIcon from "@mui/icons-material/Create";
import DeviceHub from "@mui/icons-material/DeviceHub";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import SchoolIcon from "@mui/icons-material/School";
import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import { City, Country, State } from "country-state-city";
import React, { useEffect, useState } from "react";
import Avatar from "react-avatar";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import {
  errorRegisterUser,
  errorSnackbar,
  successSnackbar,
} from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import img from "../../assets/profile_banner.png";
import MAutocomplete from "../../components/MAutocomplete";
import MDialog from "../../components/MDialog/mDialog";
import MDropdown from "../../components/MDropdown";
import MTextField from "../../components/MTextField";
import MUserAutocomplete from "../../components/MUserAutocomplete";
import {
  DrawerItemsKey,
  PATH,
  SnackbarType,
} from "../../constants/appConstants";
import {
  isFieldEmpty,
  isObjectEmpty,
  isPhoneNumber,
  isValidEmail,
} from "../../helpers/appFieldValidation";
import SessionDetails from "../../helpers/sessionDetails";
import { cleanObjectWithParams, getCopy } from "../../helpers/utils.helper";
import { setResponsiveDialog } from "../../reducers/responsiveDialogReducer";
import { Sections } from "./constants";
import familyRelation from "./fields/familyRelation.json";
import personalInfo from "./fields/personalInfo.json";
import TagsInput from "./inputTags";
import "./profile.scss";
import { setSnackbar } from "../../reducers/snackbarReducer";

const Profile = (props) => {
  const [isPersonalInfoDialogOpen, setPersonalInfoDialogOpen] = useState(false);
  const [isFamilyDialogOpen, setFamilyDialogOpen] = useState(false);
  const [isProfessionalInfoDialogOpen, setProfessionalInfoDialogOpen] =
    useState(false);
  const [isSkillsDialogOpen, setSkillsDialogOpen] = useState(false);
  // const [submittedData, setSubmittedData] = useState(null);
  const [options, setOptions] = useState([]);
  const [inputFamilyUserValue, setInputFamilyUserValue] = useState("");
  const [pendingRelationRequests, setPendingRelationRequests] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState({
    bloodGroup: "",
    gender: "",
    maritalStatus: "",
    profession: "",
    qualification: "",
    country: "",
    state: "",
    city: "",
    jamaat: "",
    "firstName-salutation": "",
  });

  const [sectionDetails, setSectionDetails] = useState({
    personal: {
      bloodGroup: "",
      gender: "",
      maritalStatus: "",
      country: "",
      state: "",
      city: "",
      jamaat: "",
      "firstName-salutation": "",
    },
    family: {},
    education: {},
    skills: {},
  });

  console.log(user, "this is console");
  const [location, setLocation] = useState({
    country: Country.getAllCountries(),
    state: [],
    city: [],
  });

  const [locationOptions, setLocationOptions] = useState({
    country: {},
    state: {},
    city: {},
    jamaat: {},
  });
  const [jamaats, setJamaats] = useState([]);
  const [validation, setValidation] = useState([]);
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    getJamatList();
    // getPendingRelationRequests();
  }, []);

  const getJamatList = () => {
    AjaxHelper.getApi(navigate, Endpoint.GET_JAMAATS)
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          setJamaats(response.data.data);
          getUserData(response.data.data);
        } else {
          dispatch(errorSnackbar("Error fetching jamaat list"));
        }
      })
      .catch((err) => {
        dispatch(errorSnackbar("Error fetching jamaat list"));
      });
  };

  const handleDropdownChange = (value, type, section) => {
    const updatedSectionDetails = getCopy(sectionDetails);
    const updatedUser = updatedSectionDetails[section];
    const updatedLocation = getCopy(location);
    const updatedLocationOptions = getCopy(locationOptions);
    updatedLocationOptions[type] = value;

    let cityApiCalled = false;

    switch (type) {
      case "country":
        updatedUser.country = value.name;
        updatedUser.countryCode = value.isoCode;
        updatedUser.state = "";
        updatedUser.city = "";
        updatedLocation.state = State.getStatesOfCountry(
          updatedUser.countryCode
        );
        updatedLocation.city = [];
        break;
      case "state":
        updatedUser.state = value.name;
        updatedUser.stateCode = value.isoCode;
        updatedUser.city = "";
        updatedLocation.city = [];
        cityApiCalled = true;
        break;
      case "city":
        updatedUser.city = value.name;
        break;
      case "jamaat":
        updatedUser.jamatName = value.name;
        updatedUser.jamatCode = value.code;
        break;
      default:
        break;
    }
    console.log(updatedLocation);
    setSectionDetails(updatedSectionDetails);
    setLocation(updatedLocation);
    setLocationOptions(updatedLocationOptions);
    if (cityApiCalled) {
      getCities(updatedUser.countryCode, updatedUser.stateCode);
    }
  };

  const getCities = (country, state) => {
    AjaxHelper.getApi(navigate, Endpoint.GET_CITIES, null, {
      state: state,
      country: country,
    })
      .then((response) => {
        if (
          response.data.status === Status.API_SUCCESS ||
          response.data.status === Status.API_NO_CONTENT
        ) {
          let city = City.getCitiesOfState(country, state);
          let newCities = city.concat(response.data.data);
          let updatedLocation = getCopy(location);
          if (newCities.length > 0) {
            updatedLocation.city = newCities.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            });
          } else {
            updatedLocation.city = { name: state };
          }
          setLocation(updatedLocation);
        } else {
          dispatch(errorRegisterUser);
        }
      })
      .catch((err) => {
        dispatch(errorRegisterUser);
      });
  };

  const getUserData = (listOfJamaat) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_USER)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          let userData = response.data.data;
          SessionDetails.saveCurrentUser(userData);
          setupUserData(userData, listOfJamaat);
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
      });
  };

  const setupUserData = (userData, listOfJamaat) => {
    setSkills(userData.skills ?? []);
    getCities(userData.countryCode, userData.stateCode);
    userData.qualification = userData.qualification[0];
    userData.profession = userData.profession[0];
    userData.street = userData.address[0].street;
    userData.landMark = userData.address[0].landMark
      ? userData.address[0].landMark
      : "";
    userData.society = userData.address[0].society;
    userData.phonecode = userData.countryCallingCode;
    userData["firstName-salutation"] = userData.title;
    setUser(userData);
  };

  const setupSections = (data) => {
    let sectionData = {};
    Object.keys(Sections).forEach((section) => {
      const params = cleanObjectWithParams(
        data,
        Sections[section].formFields.map((f) => f.key)
      );
      sectionData[section] = params;
      if (section === Sections.personal.key) {
        sectionData[section].street = data.address[0].street;
        sectionData[section].landMark = data.address[0].landMark
          ? data.address[0].landMark
          : "";
        sectionData[section].society = data.address[0].society;
        sectionData[section].phonecode = data.countryCallingCode;
        sectionData[section]["firstName-salutation"] = data.title;
      } else if (section === Sections.education.key) {
        sectionData[section].qualification =
          typeof data.qualification === "string"
            ? data.qualification
            : data.qualification[0];
        sectionData[section].profession =
          typeof data.profession === "string"
            ? data.profession
            : data.profession[0];
      }
    });
    setSectionDetails(sectionData);

    // Setup dropdowns
    const updatedLocationOptions = getCopy(locationOptions);
    updatedLocationOptions.country = Country.getAllCountries().filter(
      (country) => country.isoCode === user.countryCode
    )[0];
    updatedLocationOptions.state = State.getStatesOfCountry(
      user.countryCode
    ).filter((state) => state.isoCode === user.stateCode)[0];
    updatedLocationOptions.city = City.getCitiesOfState(
      user.countryCode,
      user.stateCode
    ).filter((city) => city.name === user.city)[0];
    updatedLocationOptions.jamaat = jamaats.filter(
      (j) => j.code === user.jamatCode
    )[0];

    const updatedLocation = getCopy(location);
    updatedLocation.state = State.getStatesOfCountry(user.countryCode);
    setLocation(updatedLocation);
    setLocationOptions(updatedLocationOptions);
  };

  const handleChange = (e, section) => {
    const updatedProfile = getCopy(sectionDetails);
    updatedProfile[section][e.target.name] = e.target.value;
    setSectionDetails(updatedProfile);
  };

  const handleFamilyChange = (key, value) => {
    const updatedSectionDetails = getCopy(sectionDetails);
    const updatedFamily = updatedSectionDetails[Sections.family.key];
    updatedFamily[key] = value;
    setSectionDetails(updatedSectionDetails);
  };

  const getValidation = (section) => {
    const validations = Sections[section].formFields
      .map((field) => {
        if (getFieldRequired(field)) {
          if (field.key === "dateOfBirth") {
            if (sectionDetails[section][field.key] === "now") {
              return {
                name: field.key,
                validation: `${field.label} is mandatory.`,
              };
            }
          }

          if (isFieldEmpty(sectionDetails[section][field.key])) {
            if (field.key === "mobile") {
              if (isFieldEmpty(sectionDetails[section]["phonecode"])) {
                return {
                  name: "mobile",
                  titleError: true,
                  validation: "Please select country code.",
                };
              } else {
                return {
                  name: field.key,
                  validation: `${field.label} is mandatory.`,
                };
              }
            } else if (field.key === "firstName") {
              if (
                isFieldEmpty(sectionDetails[section]["firstName-salutation"])
              ) {
                return {
                  name: field.key,
                  titleError: true,
                  validation: "Please select title.",
                };
              } else {
                return {
                  name: field.key,
                  validation: `${field.label} is mandatory.`,
                };
              }
            } else if (field.key === "jamaat") {
              if (isFieldEmpty(sectionDetails[section]["jamatName"])) {
                return {
                  name: field.key,
                  validation: `${field.label} is mandatory.`,
                };
              }
            } else {
              return {
                name: field.key,
                validation: `${field.label} is mandatory.`,
              };
            }
          } else {
            if (field.key === "email") {
              if (!isValidEmail(sectionDetails[section]["email"])) {
                return {
                  name: "email",
                  validation: "Please enter valid email.",
                };
              }
            } else if (field.key === "mobile") {
              if (!isPhoneNumber(sectionDetails[section]["mobile"])) {
                return {
                  name: "mobile",
                  validation: "Please enter valid phone number.",
                };
              }
            }
          }
        }
        return {};
      })
      .filter((validation) => !isObjectEmpty(validation));

    setValidation(validations);

    if (validations.length > 0) {
      dispatch(
        setResponsiveDialog(
          true,
          "Form errors",
          "Please resolve the errors in the form to submit it.",
          "OK"
        )
      );
    }
    return validations.length === 0;
  };

  const getFieldDisable = (field) => {
    if (field.disabled === undefined) {
      return false;
    }

    if (field.disabled.condition === undefined) {
      return field.disabled.value;
    }

    const conditionFields = field.disabled.condition.fields;
    const conditionArray = [];
    conditionFields.forEach((conditionField) => {
      const fieldValue = user[conditionField.key];
      conditionArray.push(!conditionField.values.includes(fieldValue));
    });

    return !conditionArray.includes(false);
  };

  const getFieldRequired = (field) => {
    const disabled = getFieldDisable(field);
    if (disabled) {
      return false;
    } else {
      return field.required;
    }
  };

  const getRegisterFields = (section, formFields) => {
    return formFields.map((field) => {
      if (field.type === "dropdown") {
        return (
          <div
            className={
              (field.size === "full"
                ? "col-xl-12 col-lg-12 col-md-12"
                : "col-xl-6 col-lg-6 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MDropdown
              id={field.key}
              key={field.key}
              className={"input"}
              required={getFieldRequired(field)}
              label={field.label}
              name={field.key}
              value={sectionDetails[section][field.key]}
              onChange={(event) => handleChange(event, section)}
              placeholder={field.placeholder}
              options={field.options}
              error={getFieldError(field.key)}
              helperText={getFieldErrorText(field.key)}
            />
          </div>
        );
      } else if (field.type === "text") {
        if (field.salutation) {
          return (
            <div
              className={
                (field.size === "half"
                  ? "col-xl-6 col-lg-6 col-md-12"
                  : "col-xl-12 col-lg-12 col-md-12") +
                "  col-12 d-flex justify-content-center align-items-center"
              }
            >
              <div className={"col-3"}>
                <MDropdown
                  id={field.key + "-salutation"}
                  key={field.key + "-salutation"}
                  required={getFieldRequired(field)}
                  label={"Title"}
                  name={field.key + "-salutation"}
                  value={sectionDetails[section][field.key + "-salutation"]}
                  onChange={(event) => handleChange(event, section)}
                  placeholder={""}
                  options={field.salutation}
                  error={getFieldTitleError(field.key)}
                  helperText={getFieldTitleError(field.key) ? "Error" : ""}
                />
              </div>
              <div className={"col-9"}>
                <MTextField
                  id={field.key}
                  name={field.key}
                  required={getFieldRequired(field)}
                  label={field.label}
                  value={sectionDetails[section][field.key]}
                  onChange={(event) => handleChange(event, section)}
                  disabled={getFieldDisable(field)}
                  error={getFieldError(field.key)}
                  placeholder={field.placeholder}
                  helperText={getFieldErrorText(field.key)}
                  multiline={field.multiline}
                />
              </div>
            </div>
          );
        } else {
          return (
            <div
              className={
                (field.size === "half"
                  ? "col-xl-6 col-lg-6 col-md-12"
                  : "col-xl-12 col-lg-12 col-md-12") +
                "  col-12 d-flex justify-content-center align-items-center"
              }
            >
              <MTextField
                id={field.key}
                name={field.key}
                className="col-12"
                required={getFieldRequired(field)}
                label={field.label}
                value={sectionDetails[section][field.key]}
                onChange={(event) => handleChange(event, section)}
                disabled={getFieldDisable(field)}
                error={getFieldError(field.key)}
                placeholder={field.placeholder}
                helperText={getFieldErrorText(field.key)}
                multiline={field.multiline}
              />
            </div>
          );
        }
      } else if (
        field.type === "country" ||
        field.type === "state" ||
        field.type === "city"
      ) {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-6 col-md-12"
                : "col-xl-12 col-lg-12 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MAutocomplete
              id={field.key}
              value={locationOptions[field.key]}
              key={field.key}
              inputValue={sectionDetails[section][field.key]}
              size="medium"
              className="input"
              required={field.required}
              onChange={(event, newValue) =>
                handleDropdownChange(newValue, field.type, section)
              }
              onInputChange={(event, newInputValue) => {
                const updatedUser = getCopy(sectionDetails);
                updatedUser[section][field.key] = newInputValue;
                setSectionDetails(updatedUser);
              }}
              options={location[field.type]}
              placeholder={field.placeholder}
              label={field.label}
              error={getFieldError(field.key)}
              helperText={getFieldErrorText(field.key)}
            />
          </div>
        );
      } else if (field.type === "datepicker") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-6 col-md-12"
                : "col-xl-12 col-lg-12 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MTextField
              id={field.key}
              name={field.key}
              key={field.key}
              className="input"
              required={getFieldRequired(field)}
              label={field.label}
              variant="filled"
              value={sectionDetails[section][field.key]}
              type={"date"}
              onChange={(event) => handleChange(event, section)}
              disabled={getFieldDisable(field)}
              error={getFieldError(field.key)}
              placeholder={field.placeholder}
              helperText={getFieldErrorText(field.key)}
            />
          </div>
        );
      } else if (field.type === "jamaat") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-6 col-md-12"
                : "col-xl-12 col-lg-12 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MAutocomplete
              id={field.key}
              size="medium"
              className="input"
              key={field.key}
              value={locationOptions[field.key]}
              inputValue={sectionDetails[section]["jamatName"]}
              required={field.required}
              onChange={(event, newValue) =>
                handleDropdownChange(newValue, field.type, section)
              }
              options={jamaats}
              placeholder={field.placeholder}
              label={field.label}
              error={getFieldError(field.key)}
              helperText={getFieldErrorText(field.key)}
              disabled={getFieldDisable(field)}
            />
          </div>
        );
      } else if (field.type === "mobile") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-6 col-md-12"
                : "col-xl-12 col-lg-12 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <div className="col-3">
              <MDropdown
                id={field.key + "-calling"}
                key={field.key + "-calling"}
                className={"input"}
                required={getFieldRequired(field)}
                label={"Code"}
                name={"phonecode"}
                value={getCallingCode()}
                onChange={(event) => handleChange(event, section)}
                placeholder={field.placeholder}
                options={location["country"].map(
                  (c) => "(" + c.isoCode + ") " + c.phonecode
                )}
                error={getFieldTitleError(field.key)}
                helperText={getFieldTitleError(field.key) ? "Error" : ""}
              />
            </div>
            <div className="col-9">
              <MTextField
                id={field.key}
                name={field.key}
                className="col-12"
                required={getFieldRequired(field)}
                label={field.label}
                value={sectionDetails[section][field.key]}
                type={"number"}
                inputProps={{ maxLength: field.numberOfCharacters }}
                onChange={(event) => handleChange(event, section)}
                disabled={getFieldDisable(field)}
                placeholder={field.placeholder}
                error={getFieldError(field.key)}
                helperText={getFieldErrorText(field.key)}
              />
            </div>
          </div>
        );
      }
    });
  };

  const getCallingCode = () => {
    if (sectionDetails[Sections.personal.key]["countryCallingCode"]) {
      const country = location["country"].filter(
        (c) =>
          c.phonecode ===
          sectionDetails[Sections.personal.key]["countryCallingCode"]
      );
      if (country.length > 0) {
        return "(" + country[0].isoCode + ") " + country[0].phonecode;
      }
    } else {
      return "(IN) 91";
    }
  };

  const getCallingCodeValue = () => {
    const country = location["country"].filter(
      (c) => "(" + c.isoCode + ") " + c.phonecode === user["phonecode"]
    );
    if (country.length > 0) {
      return country[0].phonecode;
    } else {
      return "91";
    }
  };

  const getFieldError = (key) => {
    const vField = validation.filter((v) => v.name === key);
    return vField.length > 0;
  };

  const getFieldErrorText = (key) => {
    const vField = validation.filter((v) => v.name === key);
    if (vField.length > 0) {
      return vField[0].validation;
    } else {
      return "";
    }
  };

  const getFieldTitleError = (key) => {
    const vField = validation.filter((v) => v.name === key);
    if (vField.length > 0) {
      return vField[0].titleError ? vField[0].titleError : false;
    } else {
      return false;
    }
  };

  const updateUser = (section) => {
    if (getValidation(section)) {
      setPersonalInfoDialogOpen(false);
      setProfessionalInfoDialogOpen(false);
      dispatch(startLoading);
      let updatedUser = getCopy(sectionDetails[section]);
      updatedUser._id = user._id;
      if (section === Sections.personal.key) {
        updatedUser.title = updatedUser["firstName-salutation"];
        updatedUser.countryCallingCode = getCallingCodeValue();
        updatedUser.address = {
          society: updatedUser.society,
          street: updatedUser.street,
          landMark: updatedUser.landMark,
        };
      }
      updateUseApi(updatedUser);
    }
  };

  const updateUseApi = (params) => {
    AjaxHelper.postApi(navigate, Endpoint.UPDATE_USER, params)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(successSnackbar("User updated successfully"));
          setUser({ ...getCopy(user), ...params });
        } else {
          dispatch(errorSnackbar("Unable to update user."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while updating profile."));
      });
  };

  const updateSkills = () => {
    // validation
    const params = {
      _id: user._id,
      skills: skills,
    };
    updateUseApi(params);
  };

  const getSearchedUsers = (search) => {
    AjaxHelper.getApi(navigate, Endpoint.GET_SEARCH_USERS, null, { search })
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          const optionWithName = response.data.data.map((user) => {
            return {
              ...user,
              name: `${user.firstName} ${user.lastName}`,
            };
          });
          setOptions(optionWithName);

          console.log(optionWithName);
        } else {
          dispatch(errorSnackbar("Error fetching users list"));
        }
      })
      .catch((err) => {
        dispatch(errorSnackbar("Error fetching users list (catch error)"));
      });
  };

  const handleInputChange = (event, newInputValue) => {
    setInputFamilyUserValue(newInputValue);
    if (newInputValue.length === 4) {
      getSearchedUsers(newInputValue);
    }
    if (newInputValue.length === 3) {
      setOptions([]);
    }
  };

  const handlePersonalInfoDialogOpen = () => {
    setupSections(user);
    setPersonalInfoDialogOpen(true);
  };

  const handleFamilyDialogOpen = () => {
    setFamilyDialogOpen(true);
  };
  const handleSkillsDialogOpen = () => {
    setSkillsDialogOpen(true);
  };
  const handleProfessionalInfoDialogOpen = () => {
    setupSections(user);
    setProfessionalInfoDialogOpen(true);
  };

  const handleDialogClose = () => {
    setPersonalInfoDialogOpen(false);
    setProfessionalInfoDialogOpen(false);
    setFamilyDialogOpen(false);
  };

  const handleDialogNegative = () => {
    setPersonalInfoDialogOpen(false);
    setProfessionalInfoDialogOpen(false);
    setFamilyDialogOpen(false);
    setSkillsDialogOpen(false);
  };

  const handleDialogPositiveFamily = () => {
    if (getValidation(Sections.family.key)) {
      addRelation(familyRelation);
      setFamilyDialogOpen(false);
    }
  };
  const handleDialogPositiveSkills = () => {
    if (skills && skills.length > 0) {
      setSkillsDialogOpen(false);
      updateSkills();
    } else {
      setSkillsDialogOpen(false);
      dispatch(
        errorSnackbar("Please enter some skills to be updated in your profile.")
      );
    }
  };

  const getRelationOptions = (options) => {
    const removedOptions = [];
    if (user.parents && user.parents.length === 2) {
      removedOptions.push("parent");
    }

    if (user.spouses && user.spouses.length === 1) {
      removedOptions.push("spouse");
    }
    return options.filter(
      (option) => removedOptions.indexOf(option.toLowerCase()) < 0
    );
  };

  const getFamilyAddFields = (formFields) => {
    return formFields.map((field) => {
      if (field.type === "dropdown") {
        return (
          <div>
            <MDropdown
              id={field.key}
              key={field.key}
              className={"input"}
              required={getFieldRequired(field)}
              label={field.label}
              name={field.key}
              value={sectionDetails[Sections.family.key][field.key]}
              onChange={(e) => handleFamilyChange(field.key, e.target.value)}
              placeholder={field.placeholder}
              options={getRelationOptions(field.options)}
              error={getFieldError(field.key)}
              helperText={getFieldErrorText(field.key)}
            />
          </div>
        );
      } else {
        return (
          <MUserAutocomplete
            label={field.label}
            required={field.required}
            options={options}
            inputValue={inputFamilyUserValue}
            onChange={(event, newValue) => {
              handleFamilyChange(field.key, newValue);
            }}
            onInputChange={(event, newI) => handleInputChange(event, newI)}
            error={getFieldError(field.key)}
            helperText={getFieldErrorText(field.key)}
          />
        );
      }
    });
  };

  function handleSelecetedTags(items) {
    setSkills(items);
  }

  const addRelation = () => {
    const params = {
      to: sectionDetails.family?.user._id,
      relationshipType: sectionDetails.family?.relationshipType.toLowerCase(),
    };
    AjaxHelper.postApi(navigate, Endpoint.ADD_RELATION, params)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_CREATED) {
          dispatch(successSnackbar("Request sent successfully."));
        } else {
          dispatch(errorSnackbar("Error while sending request."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while sending request."));
      });
  };

  const getPendingRelationRequests = () => {
    AjaxHelper.getApi(navigate, Endpoint.GET_RELATION_REQUESTS)
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          setPendingRelationRequests(response.data.data);
        } else {
          console.log(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getRelativeList = (relation) => {
    let key = "";
    let displayRelation = {};
    if (relation === "Parent") {
      key = "parents";
      displayRelation = { male: "Father", female: "Mother" };
    } else if (relation === "Child") {
      key = "children";
      displayRelation = { male: "Son", female: "Daughter" };
    } else if (relation === "Spouse") {
      key = "spouses";
      displayRelation = { male: "Husband", female: "Wife" };
    } else {
      key = "siblings";
      displayRelation = { male: "Brother", female: "Sister" };
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        {user[key]
          ? user[key].map((relative) => (
              <div style={{ display: "flex", flexDirection: "row", gap: 8 }}>
                <Avatar
                  name={`${relative.firstName} ${relative.lastName}`}
                  round={true}
                  size={44}
                />
                <div>
                  <div
                    style={{ fontFamily: "MontserratMedium" }}
                  >{`${relative.firstName} ${relative.lastName}`}</div>
                  <div style={{ fontFamily: "MontserratItalic" }}>
                    {relative.userCode}
                  </div>
                  <div style={{ fontFamily: "MontserratRegular" }}>
                    {displayRelation[relative.gender.toLowerCase()]}
                  </div>
                </div>
              </div>
            ))
          : null}
      </div>
    );
  };

  const getRelationName = (relationRequest) => {
    if (relationRequest.relationshipType === "parent") {
      return relationRequest.to?.gender === "Male" ? "Father" : "Mother";
    } else if (relationRequest.relationshipType === "spouse") {
      return relationRequest.to?.gender === "Male" ? "Husband" : "Wife";
    } else if (relationRequest.relationshipType === "sibling") {
      return relationRequest.to?.gender === "Male" ? "Brother" : "Sister";
    } else {
      return relationRequest.to?.gender === "Male" ? "Son" : "Daughter";
    }
  };

  const getPendingRelationRequestUI = () => {
    return pendingRelationRequests ? (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        {pendingRelationRequests.map((relative) => (
          <div style={{ display: "flex", flexDirection: "row", gap: 8 }}>
            <Avatar
              name={`${relative.to?.firstName} ${relative.to?.lastName}`}
              round={true}
              size={44}
            />
            <div>
              <div
                style={{ fontFamily: "MontserratMedium" }}
              >{`${relative.to?.firstName} ${relative.to?.lastName}`}</div>
              <div style={{ fontFamily: "MontserratItalic" }}>
                {relative.to?.userCode}
              </div>
              <div style={{ fontFamily: "MontserratRegular" }}>
                {getRelationName(relative)}
              </div>
              <div style={{ color: "red", fontFamily: "MontserratMedium" }}>
                {" "}
                {"Pending"}
              </div>
            </div>
          </div>
        ))}
      </div>
    ) : null;
  };

  // delete user;
  const deleteAccount = () => {
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.DELETE_ACCOUNT)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(
            setSnackbar(true, SnackbarType.SUCCESS, response.data.message)
          );
          SessionDetails.clearStoredData();
          navigate(PATH.LOGIN_SCREEN, { replace: true });
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch(() => {
        dispatch(stopLoading);
        setSnackbar(true, SnackbarType.ERROR, "Cant Delete the Account");
      });
  };

  return (
    <Box className="make-center-div">
      <Card
        className="container-box"
        sx={{
          backgroundColor: "white",
          marginY: 2,
          borderRadius: 2,
          paddingBottom: 2,
        }}
        variant="outlined"
      >
        <Box>
          <Box>
            <img className="banner-img" alt="bannerImg" src={img} />
          </Box>
          <Box sx={{ backgroundColor: "white", paddingX: "16px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Avatar
                name={`${user.firstName} ${user.lastName}`}
                round={true}
                className="avatar"
              />
            </Box>
            <Box className="btnmove">
              <div>
                <Typography className="introFont">
                  {user.firstName} {user.lastName}
                </Typography>
                <Typography className={"appFontMedium"}>
                  {user.userCode}
                </Typography>
              </div>

              <IconButton aria-label="edit" className="editbtn">
                <CreateIcon
                  onClick={handlePersonalInfoDialogOpen}
                  sx={{ color: " #BCBF4E" }}
                />
              </IconButton>
            </Box>
            <Typography
              style={{ paddingY: 1, fontSize: "20px" }}
              className={"appFont"}
            >
              {user.city}
              <FiberManualRecordIcon
                style={{ fontSize: "7px", margin: "5px" }}
                className={"appFont"}
              />
              {user.state}
              <FiberManualRecordIcon
                style={{ fontSize: "7px", margin: "5px" }}
                className={"appFont"}
              />
              {user.country}
            </Typography>
            <Typography sx={{ paddingY: 1, fontSize: "16px" }}>
              {user.bio}
            </Typography>
          </Box>
        </Box>
      </Card>
      <Card
        sx={{
          borderRadius: 2,
          backgroundColor: "White",
          paddingX: 5,
          marginY: 2,
          paddingY: 2,
        }}
        variant="outlined"
      >
        <Box className="btnmove">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Typography variant="h5">Family</Typography>

            {user.family ? (
              <div
                style={{
                  backgroundColor: "white",
                  padding: "8px",
                  borderRadius: "50%",
                  height: "42px",
                  width: "42px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "2px solid #5B7586",
                }}
                onClick={() => props.onPageChange(DrawerItemsKey.FAMILY_TREE)}
              >
                <IconButton aria-label="edit" className="editbtn">
                  <DeviceHub
                    style={{
                      color: "#5B7586",
                      padding: "2px",
                    }}
                  />
                </IconButton>
              </div>
            ) : null}
          </div>
          <IconButton aria-label="edit" className="editbtn">
            <AddIcon
              onClick={handleFamilyDialogOpen}
              sx={{ color: "#BCBF4E" }}
            />
          </IconButton>
        </Box>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 16,
            flexWrap: "wrap",
            marginTop: 16,
          }}
        >
          {Sections.family.formFields[1].options.map((relation) =>
            getRelativeList(relation)
          )}
          {getPendingRelationRequestUI()}
        </div>
      </Card>
      <Card
        variant="outlined"
        sx={{ paddingX: 5, borderRadius: 2, marginY: 2, paddingY: 2 }}
      >
        <Box className="btnmove">
          <Typography variant="h5">Education</Typography>
          <IconButton aria-label="edit" className="editbtn">
            <CreateIcon
              onClick={handleProfessionalInfoDialogOpen}
              sx={{ color: " #BCBF4E" }}
            />
          </IconButton>
          <MDialog
            title={"Professional details"}
            open={isProfessionalInfoDialogOpen}
            onClose={handleDialogClose}
            onNegative={handleDialogNegative}
            onPositive={() => updateUser(Sections.education.key)}
            negativeLabel="Cancel"
            positiveLabel="Submit"
          >
            <div>
              {getRegisterFields(
                Sections.education.key,
                Sections.education.formFields
              )}
            </div>
          </MDialog>
        </Box>
        <List>
          <ListItem>
            <SchoolIcon />
            <ListItemText sx={{ paddingX: 2 }} primary={user.qualification} />
          </ListItem>
        </List>
      </Card>
      <Card
        sx={{
          borderRadius: 2,
          backgroundColor: "White",
          paddingX: 5,
          marginY: 2,
          paddingY: 2,
        }}
        variant="outlined"
      >
        <CardContent className="btnmove">
          <Typography variant="h5">Skills</Typography>

          <IconButton aria-label="edit" className="editbtn">
            <AddIcon
              onClick={handleSkillsDialogOpen}
              sx={{ color: " #BCBF4E" }}
            />
          </IconButton>
        </CardContent>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          {(user.skills ?? []).map((skill) => (
            <Chip sx={{ backgroundColor: " #BCBF4E" }} label={skill} />
          ))}
        </div>
      </Card>
      {/* <Button
        onClick={() => {
          deleteAccount();
        }}
      >
        Delete Account
      </Button> */}
      <MDialog
        title={"Personal details"}
        open={isPersonalInfoDialogOpen}
        onClose={handleDialogClose}
        onNegative={handleDialogNegative}
        onPositive={() => updateUser(Sections.personal.key)}
        negativeLabel="Cancel"
        positiveLabel="Submit"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {getRegisterFields(Sections.personal.key, personalInfo)}
        </div>
      </MDialog>
      <MDialog
        title={"Add a relative"}
        styles={{ padding: "10px", width: "50%" }}
        open={isFamilyDialogOpen}
        onClose={handleDialogClose}
        onNegative={handleDialogNegative}
        onPositive={handleDialogPositiveFamily}
        negativeLabel="Cancel"
        positiveLabel="Submit"
      >
        {getFamilyAddFields(familyRelation)}
      </MDialog>
      <MDialog
        title={"Add skills"}
        open={isSkillsDialogOpen}
        onClose={handleDialogClose}
        onNegative={handleDialogNegative}
        onPositive={handleDialogPositiveSkills}
        negativeLabel="Cancel"
        positiveLabel="Submit"
      >
        <div className={"col-12"}>
          <TagsInput
            selectedTags={handleSelecetedTags}
            fullWidth
            variant="outlined"
            id="tags"
            name="tags"
            placeholder="Press Enter to add"
            label="Skills"
            tags={skills}
          />
        </div>
      </MDialog>
    </Box>
  );
};

export default Profile;
